import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate  } from "react-router-dom";
import SelectionPage from "./pages/SelectionPage";
import FlacheGeothermie from "./pages/FlacheGeothermie";
import Kostenvergleich from "./pages/Kostenvergleich";
import QuickReportPage from "./pages/QuickReportPage";
import Bundeslaender from "./pages/Bundeslaender";
import BundeslandBadenWuerttemberg from "./pages/BundeslandBadenWuerttemberg"; 
import BundeslandBayern from "./pages/BundeslandBayern"; 
import BundeslandBerlin from "./pages/BundeslandBerlin"; 
import BundeslandBrandenburg from "./pages/BundeslandBrandenburg"; 
import BundeslandBremen from "./pages/BundeslandBremen"; 
import BundeslandHamburg from "./pages/BundeslandHamburg"; 
import BundeslandMecklenburgVorpommern from "./pages/BundeslandMecklenburgVorpommern"; 
import BundeslandNordrheinWestfalen from "./pages/BundeslandNordrheinWestfalen"; 
import TiefeGeothermie from "./pages/TiefeGeothermie";
import FAQ from "./pages/FAQ";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Haftung from "./pages/Haftung";
import AGB from "./pages/AGB";
import Kontakt from "./pages/Kontakt";
import Navbar from "./assets/Navbar";
import Footer from "./assets/Footer";
import ScrollToTop from "./components/ScrollToTop";
import SeoManager from "./components/SeoManager";
import NotFound from "./pages/NotFound";
import { Analytics } from "@vercel/analytics/react";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";


function App() {
  // ⛔ Wartungsmodus aktiv?
  if (process.env.REACT_APP_MAINTENANCE_MODE === "true") {
    return (
      <div style={{ padding: 40, fontSize: "1.2rem" }}>
        <h2>Wartungsmodus</h2>
        <p>Die Website wird aktuell überarbeitet und ist bald wieder verfügbar.</p>
      </div>
    );
  }


  return (
      <>
    <Router>
	  <ScrollToTop />
	  <Navbar />
      <Routes>
        <Route path="/intro" element={<Navigate to="/" replace />} />
        <Route path="/select" element={<Navigate to="/" replace />} />
        <Route path="/" element={<SelectionPage />} />
        	<Route path="/flache-geothermie" element={<FlacheGeothermie />} />
		<Route path="/erdwaermepumpe-kosten" element={<Kostenvergleich />} />
		<Route path="/kostenvergleich" element={<Navigate to="/erdwaermepumpe-kosten" replace />} />
		<Route path="/kosten" element={<Navigate to="/erdwaermepumpe-kosten" replace />}/>
		<Route path="/quicktherm" element={<Navigate to="/flache-geothermie" replace />} />
		<Route path="/flache_geothermie" element={<Navigate to="/flache-geothermie" replace />} />
		<Route path="/report" element={<QuickReportPage />} />
		<Route path="/tiefe_geothermie" element={<TiefeGeothermie />} />
		<Route path="/faq" element={<FAQ />} />
		<Route path="/impressum" element={<Impressum />} />
		<Route path="/datenschutz" element={<Datenschutz />} />
		<Route path="/haftung" element={<Haftung />} />
		<Route path="/agb" element={<AGB />} />
		<Route path="/contact" element={<Kontakt />} />
		<Route path="/success" element={<Success />} />
  		<Route path="/cancel" element={<Cancel />} />
  	        <Route path="/bundeslaender" element={<Bundeslaender />} />
  	<Route path="/bundeslaender/baden-wuerttemberg" element={<BundeslandBadenWuerttemberg />} />
        <Route path="/bundeslaender/bayern" element={<BundeslandBayern />} />
        <Route path="/bundeslaender/berlin" element={<BundeslandBerlin />} />
        <Route path="/bundeslaender/brandenburg" element={<BundeslandBrandenburg />} />
        <Route path="/bundeslaender/bremen" element={<BundeslandBremen />} />
	<Route path="/bundeslaender/hamburg" element={<BundeslandHamburg />} />
	<Route path="/bundeslaender/mecklenburg-vorpommern" element={<BundeslandMecklenburgVorpommern />} />
        <Route path="/bundeslaender/nordrhein-westfalen" element={<BundeslandNordrheinWestfalen />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <SeoManager />
	  <Footer />   {/* ✅ Footer am Ende jeder Seite */}
    <Analytics />
    </Router>

    </>
  );
}

export default App;
